import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('academic');

export class Setting extends Api {
  constructor(http, config = {}) {
    super(http, url, 'setting', config);
  }
}
